export var LoginDataAdaptor = function(accountObject, eid) {
    /**
     *
     * @param {Object} accountObject
     * @return {{}}
     */
    function getAccount(accountObject) {
        var account = {};

        if (accountObject) {
            var primaryPerson = accountObject.getPrimaryPerson();

            account.id = accountObject.id;
            account.setupDate = accountObject.setupDate;
            account.sponsorId = accountObject.sponsorID;
            account.referrerId = accountObject.recruiterID;
            account.country = accountObject.country;
            account.currency = '';
            // todo Need to map value to 3 character language.
            account.preferredLanguage = accountObject.preferredLanguage;
            account.customerType = accountObject.beType;
            account.temporary = accountObject.temporary;
            account.deleted = accountObject.deleted;
            account.disabled = '';
            account.birthdate = primaryPerson.birthDate;
            account.applicationDate = '';
            account.createdDate = '';
            account.lastLoginTime = '';
            account.priceType = '';
            account.passwordHint = '';
            account.forceChangePassword = '';
            account.preferredName = primaryPerson.preferredName;
            account.businessName = accountObject.names.default;
            account.volume = '';
            account.addresses = getAddresses(accountObject);
            account.contacts = getContacts(accountObject);
        }

        return account;
    }

    /**
     *
     * @param {Object} accountObject
     * @return {Array}
     */
    function getAddresses(accountObject) {
        var addresses = [];

        if (accountObject) {
            if (accountObject.addresses.default) {
                addresses.push(getAddress('default', accountObject.addresses.default));
            }
            if (accountObject.addresses.local) {
                addresses.push(getAddress('local', accountObject.addresses.local));
            }
            if (accountObject.addresses.local2) {
                addresses.push(getAddress('local2', accountObject.addresses.local2));
            }
            if (accountObject.addresses.nonLocal) {
                addresses.push(getAddress('nonLocal', accountObject.addresses.nonLocal));
            }
        }

        return addresses;
    }

    /**
     *
     * @param {String} addressType
     * @param {Object} addressData
     * @return {{}}
     */
    function getAddress(addressType, addressData) {
        var address = {};

        if (addressData) {
            address.street1 = addressData.line1;
            address.street2 = addressData.line2;
            address.street3 = '';
            address.city = addressData.city;
            address.district = addressData.district;
            address.region = addressData.region;
            address.countryCode = addressData.country;
            address.postalCode = addressData.postalCode;
            address.type = addressType;
        }

        return address;
    }

    /**
     *
     * @param {Object} accountObject
     * @return {Array}
     */
    function getContacts(accountObject) {
        var contacts = [];

        if (accountObject) {
            if (accountObject.phoneNumbers.home) {
                contacts.push(getContact('home', accountObject.phoneNumbers.home));
            }
            if (accountObject.phoneNumbers.mobile) {
                contacts.push(getContact('mobile', accountObject.phoneNumbers.mobile));
            }
            if (accountObject.phoneNumbers.work) {
                contacts.push(getContact('work', accountObject.phoneNumbers.work));
            }
            if (accountObject.phoneNumbers.fax) {
                contacts.push(getContact('fax', accountObject.phoneNumbers.fax));
            }
        }

        return contacts;
    }

    /**
     *
     * @param {String} contactType
     * @param {Object} contactdata
     * @return {{}}
     */
    function getContact(contactType, contactdata) {
        var contact = {};

        if (contactdata) {
            contact.type = contactType;
            contact.value = contactdata.value;
            contact.country = contactdata.country;
        }

        return contact;
    }

    /**
     *
     * @param {Object} accountObject
     * @return {{}}
     */
    function getPerson(accountObject) {
        var person = {};

        if (accountObject) {
            var primaryPerson = accountObject.getPrimaryPerson();

            person.id = '';
            person.sapID = accountObject.id;
            person.personID = primaryPerson.id;
            person.gigyaUID = '';
            person.createDate = '';
            person.changeDate = '';
            person.changeByName = '';
            person.localName = primaryPerson.names.local.getFormattedName();
            person.firstName = primaryPerson.names.given;
            person.lastName = primaryPerson.names.family;
            person.type = primaryPerson.type;
            person.accountDeleted = accountObject.deleted;
            person.email = primaryPerson.email;
        }

        return person;
    }

    return {
        account: getAccount(accountObject),
        person: getPerson(accountObject),
        eid: eid
    };
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/loginDataAdaptor.js
// module id = 358
// module chunks = 0